import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

import { environment } from '@env/environment';

@Injectable({
    providedIn: 'root'
})
export class CatalogueService {

    constructor(public http: HttpClient) { }

    merchandiseCateloge() {
        return this.http.get(`${environment.baseUrl + environment.version}sso/catalogue/MERCH`).pipe(map((response: any) => {
            return response;
        }));
    }

    experianceCatelogue() {
        return this.http.get(`${environment.baseUrl + environment.version}sso/experienceCatalogue/EXPER`).pipe(map((response: any) => {
            return response;
        }));
    }

    redirectMerchandiseCatalogue() {
        if (document.getElementById('catalogueForm') != null)
            document.getElementById('catalogueForm').remove();
        this.merchandiseCateloge().subscribe(response => {
            let form = $('<form id="catalogueForm" target="_blank" action="' + response.redirectUrl + '" method="post">' +
                '<input type="hidden" name="token" value="' + response.sessionId + '" />' +
                '</form>');
            $('body').append(form);
            form.trigger('submit');
        });
    }

    redirectExperianceCatalogue() {
        this.experianceCatelogue().subscribe(response => {
            if (document.getElementById('experiencCatalogueForm') != null)
                document.getElementById('experiencCatalogueForm').remove();
            let result = JSON.parse(response.postData);
            let bodyContent = ''
            for (let key in result) {
                bodyContent = bodyContent + '<input type="hidden" name="' + key + '" value="' + result[key] + '" />';
            }
            bodyContent = bodyContent + '<input type="hidden" name="media_label" value="track points" />';
            bodyContent = bodyContent + '<input type="hidden" name="product_type" value="a" />';
            bodyContent = bodyContent + '<input type="hidden" name="action_type" value="A" />';
            let form = $('<form id="experiencCatalogueForm" target="_blank" action="' + response.url + '" method="post">' +
                bodyContent +
                '</form>');
            $('body').append(form);
            form.trigger('submit');
        });
    }
}
